<template>
  <div class="table-row pinned-tab">
    <!-- <div class="report-side-panel bench-overview-side-panel q-box-shadow fromleft"> -->
    <div class="report-side-panel">
      <div class="sub-header">
        <!--- <report-header></report-header>-->
        <div class="date-range">
          <!--<VueDatePicker v-model="year" :min-date="min_date" :max-date="max_date" type="year" />-->
          <div class="col position">
            <div class="select-wrapper" :class="yearClassObject">
              <v-select
                :options="years"
                label="year"
                clear-button-icon="false"
                v-model="year"
                @input="setYear"
              ></v-select>
            </div>
          </div>
          <div class="col position" :class="[officeClassObject,dissableeClassObject]">
            <div class="select-wrapper">
              <v-select
                :options="oEData"
                label="OECountry"
                clear-button-icon="false"
                v-model="office"
                @input="setCostCenter"
              ></v-select>
            </div>
          </div>
          <p class="col position" :class="noOEMessage" style="color:red">No OE Found For The User</p>
          <div class="download-button-wrapper">
            <a
              data-v-200367fa
              href
              class="cta-btn release-btn"
              @click.prevent="exportExcel()"
            >Download</a>
          </div>
          <!-- <i class="csv-export button-export" @click.stop="exportExcel()"></i> -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import _ from "lodash";
export default {
  name: "FinanceReportRelation",
  data: () => {
    return {
      error: false,
      disablediv:false,
      disablemsg:true,
      masterTableWidth: 0,
      loadMore: true,
      timeout: 0,
      year: new Date().getFullYear(),
      office: {
          ItemId: 0,
           OECountry: "Choose OE"
        }
    };
  },
  components: {
  },
  computed: {
    filter: function() {
      return this.$store.state.qtimeReports.financeReportfilter;
    },
    yearClassObject: function() {
      return { "error-border": this.error };
    },
    years() {
      const year = new Date().getFullYear();
      let years = Array.from(
        { length: year - 2017 },
        (value, index) => 2018 + index
      );
      return years;
    },
    officeData: function() {
      if (this.$store.state.qtimeReports.costCenters.length > 0) {
        let officeData = _.cloneDeep(
          this.$store.state.qtimeReports.costCenters
        );
        officeData.push({
          ItemId: 0,
          OfficeName: "Choose office"
        });
        return officeData;
      }
      else{
        let officeData = [];
        officeData.push({
          ItemId: 0,
          OfficeName: "Choose office"
        });
        return officeData;
      }
    },
    officeClassObject: function() {
      return { "error-border": this.error };
    },
    dissableeClassObject: function() {
      return { "disabled-div": this.disablediv };
    },
    noOEMessage: function() {
      return { "disable-msg": this.disablemsg };
    },
    oEData: function() {
      if (this.$store.state.qtimeReports.oes.length > 0) {
        this.disablediv = false;
        this.disablemsg = true;
        let oEData = _.cloneDeep(
          this.$store.state.qtimeReports.oes
        );
        oEData.push({
          ItemId: 0,
          OECountry: "Choose OE"
        });
        return oEData;
      }
      else{
        this.disablediv = true;
        this.disablemsg = false;
        let oEData = [];
        oEData.push({
          ItemId: 0,
          OECountry: "Choose OE"
        });
        return oEData;
      }
    },
  },
  beforeMount() {
    this.$store.dispatch("fetchOE");
  },
  methods: {
    exportExcel: function() {
      if (this.year !== "Choose Year" && this.office.ItemId!=0) {
        this.error = false;
        let filter = _.cloneDeep(this.filter);
        // send request
        this.$store.dispatch("exportFinanceReport", filter);
      } else {
        this.error = true;
      }
    },
    setYear() {
      this.$store.commit("setfinanceReportYear", this.year);
    },
    setCostCenter() {
      this.$store.commit("setfinanceReportCostCentreId", this.office.ItemId);
    }
  },
  updated() {},
  mounted() {},

  destroyed() {},
  watch: {}
};
</script>
<style scoped>
.error-border {
  border: 1px solid red;
}

.table-row {
  padding: 20px 20px 10px 20px;
  background: none;
  border: 1px solid rgba(192, 192, 192, 0.3411764705882353);
  border-radius: 11px;
}

.qtime-activity-view {
  width: 100%;
}

.table-row .position {
  width: 100%;
  max-width: 100%;
  padding: 0;
  margin-bottom: 10px;
}

.month-year-label {
  margin-bottom: 10px;
}

.download-button-wrapper {
  width: 100%;
  text-align: center;
}

.cta-btn {
  padding: 7px 19px;
  margin: 0 auto;
}

.sub-header .date-range,
.sub-header{
  border-top: none !important;
  border-bottom: none !important;
}

.table-row{
  height: 206px;
}



@media screen and (max-width: 1573px){
  .sub-header .date-range{
      padding-left: 0;
      }
}

.disabled-div
{
  pointer-events: none;

  /* for "disabled" effect */
  opacity: 0.5;
  background: #CCC;
}
p.disable-msg {
  display: none;
}
</style>